<template>
  <el-dialog
    :title="$t('user_profile.delete_account.modals.title')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape=true
    custom-class="elsa-modal"
    :center=false
    width="255"
    top="100px"
    v-on:closed="closed"
  >
    <api-errors :errors="errors" />
    <h2>{{$t('user_profile.delete_account.modals.warning', { organizationName: organizationName })}}</h2>
    <el-form
      :model="form"
      :rules="rules"
      ref="deleteAccountForm"
      @change.native="onDeleteAccountFormChange"
    >
      <elsa-input
        type='password'
        name='password'
        :label="$t('user_profile.delete_account.modals.password')"
        v-model="form.password"
      >
      </elsa-input>
      <el-form-item prop="termsAndConditions" class="terms-and-conditions">
        <el-checkbox
          v-model="form.termsAndConditions"
          class="elsa-checkbox"
          name='termsAndConditions'
          :label="$t('user_profile.delete_account.modals.terms_and_conditions')"
        >
          </el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <primary-button
        :disabled="true"
        ref="sumbitButton"
        @click.native="handleDeleteAccountClick"
      >
        {{ $t('user_profile.delete_account.modals.delete_account') }}
      </primary-button>
      <tertiary-button @click.native="handleClose">
        {{ $t('user_profile.delete_account.modals.cancel') }}
      </tertiary-button>
    </span>
  </el-dialog>
</template>

<script>
  import ApiErrors from '@/components/common/ApiErrors'
  import ElsaInput from '@/components/common/Input'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import {
    compose,
    prop,
    head,
    propOr,
    isEmpty,
    either
  } from 'ramda';
  import { handleFormValidation, handleSubmitButtonState, isPropEmpty } from '../../../helpers/formValidationHelper';

  export default {
    data () {
      return {
        errors: [],
        form: { termsAndConditions: [] },
        rules: {
          termsAndConditions: [
            {
            required: true,
            message: this.$t('user_profile.delete_account.modals.terms_validation_msg'),
            trigger: 'change',
            validator: (rule, value, callback) => {
              return isEmpty(value) ? callback(new Error()) : callback() }
          },
        ],
          password: [
            { required: true, message: this.$t('user_profile.delete_account.modals.password_validation_msg'), trigger: 'blur' },
          ]
        },
      }
    },
    props: ["dialogVisible", "organzationData", "userId"],
    components: {
      PrimaryButton,
      TertiaryButton,
      ElsaInput,
      ApiErrors,
    },
    methods: {
      onDeleteAccountFormChange () {
        const button = this.$refs.sumbitButton.$el;
        const isInvalid = either(
          isPropEmpty('password'),
          isPropEmpty('termsAndConditions')
        )(this.form)
        return handleSubmitButtonState(button, isInvalid)
      },
      handleDeleteAccountClick () {
        const form = this.$refs.deleteAccountForm

        return handleFormValidation(form, this.handleDeleteAccount.bind(this), this.showError)
       },
      handleDeleteAccount () {
        return this.$axios.delete(`/user/${this.userId}`)
          .then(this.handleClose)
      },
      showError () {
      },
      handleCancelClick () { this.$emit("closed") },
      handleClose () { this.$emit("closed") },
      closed () {
      }
    },
    computed: {
      organizationName: compose(prop('name'), head, propOr([],'organzationData')),
    }
  }
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  line-height: 24px;
}

.el-dialog.elsa-modal {
  h2::v-deep {
    font-weight: 500;
    font-size: 18px;
    color: #546873;
  }

  &::first-letter {
    text-transform: capitalize;
  }

  .elsa-checkbox::v-deep .el-checkbox__input + .el-checkbox__label {
  font-weight: normal;
  font-size: 12px;
  color: #546873;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;

    &::first-letter {
      text-transform: capitalize;
    }
  }

  .terms-and-conditions {
    display: flex;
    margin-bottom: 0px;
    line-height: initial;

    .el-form-item__content::v-deep {
      line-height: 24px;
    }
  }
}

</style>
